import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Weddingcarrentalmumbai() {



    const cardData = {

keyword: "Wedding Car Rental Mumbai",

headingDescription:
    "Mumbai Airport Cab offers premium and reliable Wedding Car Rental in Mumbai for weddings, engagements, receptions, bridal entries, groom arrivals, and family functions. We provide luxury and comfortable vehicles including Sedan, SUV, Innova Crysta, premium luxury cars, vintage wedding cars, Tempo Traveller, Luxury Urbania, and Mini Bus options with professional chauffeurs for a smooth and elegant experience. With well-decorated cars on request, punctual service, doorstep pickup across Mumbai, flexible rental packages, and transparent pricing, we ensure your special day is stylish, comfortable, and truly memorable.",

topPlaces: [
    {
        title: "Lonavala & Khandala",
        description:
            "Lonavala and Khandala are the most popular wedding shoot destinations near Mumbai, known for misty hills, waterfalls, green valleys, and scenic viewpoints. Couples often choose this location for romantic pre-wedding shoots, cinematic drone shots, and luxury car entries due to its natural beauty and easy highway access."
    },
    {
        title: "Alibaug Beaches",
        description:
            "Alibaug is a top coastal wedding destination near Mumbai famous for clean beaches, luxury resorts, and peaceful sunset views. It is widely chosen for beach wedding shoots, couple photography, and destination wedding events with elegant seaside backdrops."
    },
    {
        title: "Karjat Riverside Locations",
        description:
            "Karjat offers beautiful riverbanks, greenery, hills, and rustic village-style landscapes. It is ideal for natural and cinematic wedding shoots where couples prefer peaceful surroundings, river views, and outdoor romantic photography."
    },
    {
        title: "Lavasa City",
        description:
            "Lavasa is a planned hill city known for its colorful European-style architecture, lakeside promenade, and scenic surroundings. It is a popular destination for stylish pre-wedding shoots and luxury wedding photography with modern aesthetic backgrounds."
    },
    {
        title: "Igatpuri Hills",
        description:
            "Igatpuri is a serene hill station surrounded by mountains, waterfalls, and cloudy weather. It is perfect for romantic wedding shoots, nature-themed photography, and cinematic video shoots during monsoon and winter seasons."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is a famous hill station known for strawberry farms, valleys, viewpoints, and cool weather. Couples often choose this destination for grand pre-wedding shoots and destination wedding photography with scenic mountain backdrops."
    },
    {
        title: "Navi Mumbai Coastal Belt",
        description:
            "The coastal areas near Navi Mumbai like Uran and Belapur offer clean beaches, quiet surroundings, and sunset views. These locations are ideal for simple yet elegant wedding shoots close to Mumbai with minimal travel."
    },
    {
        title: "Goa (Destination Wedding Route)",
        description:
            "Goa is one of India’s most popular destination wedding locations known for beaches, luxury resorts, and vibrant nightlife. Many couples book wedding cars from Mumbai for long-distance luxury travel and destination wedding transfers."
    },
    {
        title: "Pune Lavasa–Mulshi Route",
        description:
            "The Pune–Lavasa–Mulshi region offers lakes, dams, hills, and forest landscapes. It is a highly preferred route for cinematic wedding photography and luxury car shoots with scenic driving backgrounds."
    },
    {
        title: "Daman & Diu",
        description:
            "Daman and Diu are peaceful coastal destinations known for Portuguese heritage, clean beaches, and relaxed atmosphere. They are becoming popular for intimate destination wedding shoots and couple photography near Mumbai."
    }
],



services: [
{
name: "Wedding Car Rental Mumbai",
description: "Mumbai Airport Cab offers Wedding Car Rental Mumbai service for elegant, comfortable, and luxurious transportation on your special day. We provide a premium fleet of well-maintained vehicles including luxury Sedans, SUVs, Innova Crysta, Kia Carens, Mercedes, BMW, Limousine, Force Urbania, and decorated wedding cars. Whether it is bridal entry, groom arrival, wedding guests transport, or full wedding event logistics, our professional chauffeurs ensure punctual, smooth, and stress-free travel. With customized wedding packages, decorative car options, flexible booking, and 24x7 support, we make your wedding journey memorable and stylish."
},
{
name: "Mumbai Wedding Car Hire",
description: "Book Mumbai Wedding Car Hire with Mumbai Airport Cab for premium chauffeur-driven vehicles designed for wedding ceremonies, receptions, and engagement events with comfort, style, and reliability."
},
{
name: "Bridal Car Rental Mumbai",
description: "Bridal Car Rental Mumbai service provides elegant and decorated cars for bride entry, ensuring a graceful and luxurious arrival experience with professional chauffeurs and premium vehicles."
},
{
name: "Luxury Wedding Cars Mumbai",
description: "Choose Luxury Wedding Cars Mumbai for high-end vehicles including premium sedans, SUVs, and luxury brands that add sophistication and style to your wedding celebration."
},
{
name: "Wedding Chauffeur Service Mumbai",
description: "Mumbai Airport Cab provides Wedding Chauffeur Service Mumbai with trained professional drivers ensuring punctuality, elegance, and smooth transportation for all wedding functions."
},
{
name: "Wedding Car Booking Mumbai",
description: "Wedding Car Booking Mumbai offers easy reservation of luxury and decorated cars with flexible timing, multiple vehicle options, and reliable service for wedding events."
},
{
name: "Premium Wedding Cars Mumbai",
description: "Premium Wedding Cars Mumbai service includes high-end vehicles with luxury interiors, smooth rides, and professional chauffeurs for an unforgettable wedding experience."
},
{
name: "Wedding Limousine Mumbai",
description: "Wedding Limousine Mumbai service offers ultra-luxury limousine cars for grand bridal entry, groom arrival, and VIP wedding transportation with maximum comfort and style."
},
{
name: "Wedding SUV Rental Mumbai",
description: "Wedding SUV Rental Mumbai provides spacious and powerful SUVs ideal for family travel, guest transportation, and wedding logistics with comfort and elegance."
},
{
name: "Wedding Fleet Cars Mumbai",
description: "Wedding Fleet Cars Mumbai service offers multiple vehicle arrangements for large weddings including guest transportation, logistics, and coordinated travel solutions."
},
{
name: "Mumbai Bridal Entry Car",
description: "Mumbai Bridal Entry Car service provides beautifully decorated luxury vehicles designed for grand and stylish bride entry moments at wedding venues."
},
{
name: "Mumbai Wedding Transport Service",
description: "Mumbai Wedding Transport Service ensures complete transportation solutions for weddings including guest pickup, venue transfers, and event logistics with premium vehicles."
},
{
name: "Wedding Guest Transport Mumbai",
description: "Wedding Guest Transport Mumbai service offers safe and comfortable travel arrangements for guests with multiple vehicle options and coordinated scheduling."
},
{
name: "Wedding Innova Crysta Mumbai",
description: "Wedding Innova Crysta Mumbai provides spacious, comfortable, and premium travel for family and guests attending wedding ceremonies and events."
},
{
name: "Wedding Decorated Car Mumbai",
description: "Wedding Decorated Car Mumbai service offers beautifully designed and flower-decorated cars for bride and groom entry with elegant presentation."
},
{
name: "Wedding Luxury Cab Mumbai",
description: "Wedding Luxury Cab Mumbai provides premium chauffeur-driven luxury vehicles for stylish and comfortable wedding transportation."
},
{
name: "Wedding Event Car Rental Mumbai",
description: "Wedding Event Car Rental Mumbai service offers complete transport solutions for wedding functions, receptions, and ceremonies with flexible booking options."
},
{
name: "Wedding Ceremony Transport Mumbai",
description: "Wedding Ceremony Transport Mumbai ensures smooth coordination of vehicles for all wedding rituals, guest movement, and event logistics."
},
{
name: "Wedding Car Packages Mumbai",
description: "Wedding Car Packages Mumbai offers customizable packages including luxury cars, SUVs, guest transport, and decorated vehicles for complete wedding travel solutions."
},
{
name: "Wedding Hire Cars Mumbai",
description: "Wedding Hire Cars Mumbai provides a wide range of chauffeur-driven vehicles for weddings with affordable pricing, premium comfort, and reliable service."
}
],

tableData: [
["Wedding Car Rental Mumbai","Mumbai Wedding Car Hire"],
["Bridal Car Rental Mumbai","Luxury Wedding Cars Mumbai"],
["Wedding Chauffeur Service Mumbai","Wedding Car Booking Mumbai"],
["Premium Wedding Cars Mumbai","Wedding Limousine Mumbai"],
["Wedding SUV Rental Mumbai","Wedding Fleet Cars Mumbai"],
["Mumbai Bridal Entry Car","Mumbai Wedding Transport Service"],
["Wedding Guest Transport Mumbai","Wedding Innova Crysta Mumbai"],
["Wedding Decorated Car Mumbai","Wedding Luxury Cab Mumbai"],
["Wedding Event Car Rental Mumbai","Wedding Ceremony Transport Mumbai"],
["Wedding Car Packages Mumbai","Wedding Hire Cars Mumbai"]
],



whychoose: [
{
WhyChooseheading: "Premium Wedding Car Rental in Mumbai",
WhyChoosedescription: "Mumbai Airport Cabs provides elegant Wedding Car Rental services in Mumbai for weddings, receptions, engagements, pre-wedding events, and grand celebrations."
},
{
WhyChooseheading: "Luxury Vehicles for Special Occasions",
WhyChoosedescription: "Make your wedding day memorable with our premium fleet of luxury cars, SUVs, and chauffeur-driven vehicles designed for comfort and style."
},
{
WhyChooseheading: "Professional Chauffeur Services",
WhyChoosedescription: "Our experienced and well-groomed chauffeurs ensure punctual arrivals, smooth transportation, and a premium travel experience on your special day."
},
{
WhyChooseheading: "Wide Range of Wedding Vehicles",
WhyChoosedescription: "Customers can choose from Innova Crysta, luxury sedans, premium SUVs, Tempo Travellers for guests, and customized wedding transportation solutions."
},
{
WhyChooseheading: "Customized Wedding Travel Packages",
WhyChoosedescription: "Whether you require bridal entry vehicles, groom transportation, guest transfers, or complete wedding travel management, we provide flexible packages."
},
{
WhyChooseheading: "Available Across Mumbai and Nearby Cities",
WhyChoosedescription: "Wedding car rental services are available across Mumbai, Navi Mumbai, Thane, Mira Bhayandar, Borivali, Bandra, Andheri, and surrounding locations."
},
{
WhyChooseheading: "Well-Maintained and Decorated Vehicles",
WhyChoosedescription: "Our vehicles are professionally maintained and can be customized with wedding decorations according to customer preferences."
},
{
WhyChooseheading: "Ideal for Bride, Groom, and Guests",
WhyChoosedescription: "From luxury bridal cars to guest transportation arrangements, we offer suitable travel solutions for every wedding requirement."
}
]
};

const faqData = [
{
question: "What is included in Wedding Car Rental Mumbai services?",
answer: "Wedding Car Rental services include luxury vehicles, chauffeur services, bridal and groom transportation, guest transfers, and customized wedding travel arrangements."
},
{
question: "Can I book a luxury car for my wedding in Mumbai?",
answer: "Yes, customers can book premium sedans, SUVs, Innova Crysta, and other luxury vehicles for wedding ceremonies and special occasions."
},
{
question: "Do you provide decorated wedding cars?",
answer: "Yes, vehicles can be decorated according to wedding themes and customer preferences."
},
{
question: "Can I rent a car for bridal entry?",
answer: "Yes, we provide luxury vehicles suitable for bridal entry, groom entry, and wedding processions."
},
{
question: "Do you provide transportation for wedding guests?",
answer: "Yes, Tempo Travellers, SUVs, and multiple vehicles can be arranged for guest transportation."
},
{
question: "Can I book wedding cars for multiple events?",
answer: "Yes, vehicles can be booked for engagement ceremonies, mehendi, sangeet, reception, and wedding functions."
},
{
question: "Are chauffeur services included with wedding car rentals?",
answer: "Yes, professional chauffeur services are included to ensure safe and comfortable transportation."
},
{
question: "Is advance booking recommended for wedding car rentals?",
answer: "Yes, advance booking is highly recommended to ensure vehicle availability during peak wedding seasons."
},
{
question: "Can wedding car services be arranged outside Mumbai?",
answer: "Yes, wedding transportation services are available for destinations near Mumbai and outstation wedding venues."
},
{
question: "How can I book a Wedding Car Rental in Mumbai?",
answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Karan Mehta",
feedback:
"The wedding vehicle was beautifully maintained and arrived exactly on time. The chauffeur was professional and helped make our special day even more memorable.",
rating: 5
},
{
id: 2,
name: "Mrs. Neha Agarwal",
feedback:
"Mumbai Airport Cabs handled our wedding transportation perfectly. From guest transfers to bridal travel, every arrangement was smooth, organized, and stress-free.",
rating: 5
}
];












































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Wedding Car Rental Mumbai",
"image": "https://www.mumbaiairportcabs.com/assets/images/wedding-car-rental-mumbai.jpg",
"description": "Book wedding car rental in Mumbai for luxury bridal entry, guest transport, and premium wedding travel. Mumbai Airport Cabs offers decorated wedding cars, luxury sedans, SUVs, Innova Crysta, limousines, and chauffeur-driven services for your special day.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/wedding-car-rental-mumbai"
}
};






    return (
        <div>


<Helmet>
  <title>Wedding Car Rental Mumbai | Luxury Bridal Cars | +91 9545731161</title>

<meta
 name="description"
 content="Book wedding car rental in Mumbai for luxury bridal entry and guest transport. Choose from premium cars, SUVs, Innova Crysta, limousines, and decorated wedding vehicles with chauffeur service."
/>

<meta
 name="keywords"
 content="wedding car rental mumbai, mumbai wedding car hire, bridal car rental mumbai, luxury wedding cars mumbai, wedding chauffeur service mumbai, wedding car booking mumbai, premium wedding cars mumbai, wedding limousine mumbai, wedding suv rental mumbai, wedding fleet cars mumbai, mumbai bridal entry car, mumbai wedding transport service, wedding guest transport mumbai, wedding innova crysta mumbai, wedding decorated car mumbai, wedding luxury cab mumbai, wedding event car rental mumbai, wedding ceremony transport mumbai, wedding car packages mumbai"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>






            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/82.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Weddingcarrentalmumbai;